import { useNavigate } from 'react-router-dom';

export default function PublicNav({ bandId, onHome }) {
  const navigate = useNavigate();

  return (
    <nav className="flex justify-between items-center border-b border-white/[0.06] px-6 sm:px-10 py-5 bg-transparent">
      <button
        onClick={onHome}
        className="font-display text-3xl tracking-[.25em] uppercase text-brand-gold bg-transparent border-0 cursor-pointer"
      >
        Band OS
      </button>

      <div className="flex items-center gap-3">
        {bandId ? (
          <button
            onClick={() => navigate('/')}
            className="border border-white/20 text-text-muted rounded-sm px-4 py-2 text-[0.75rem] tracking-[0.1em] uppercase hover:border-white/40 hover:text-text-primary transition-colors bg-transparent cursor-pointer"
          >
            Back to app
          </button>
        ) : (
          <>
            <button
              onClick={() => navigate('/login')}
              className="border border-white/20 text-text-muted rounded-sm px-4 py-2 text-[0.75rem] tracking-[0.1em] uppercase hover:border-white/40 hover:text-text-primary transition-colors bg-transparent cursor-pointer"
            >
              Sign in
            </button>
            <button
              onClick={() => navigate('/signup')}
              className="bg-brand-gold text-[#0d0d0c] font-bold rounded-sm px-4 py-2 text-[0.75rem] tracking-[0.15em] uppercase hover:bg-brand-gold/85 transition-colors border-0 cursor-pointer"
            >
              Get stage-ready
            </button>
          </>
        )}
      </div>
    </nav>
  );
}
